import tableRelatedUserPermissions from './tableRelatedUserPermissions';

export default {
  title: 'User Permissions',
  attributeName: 'permissions',
  getURL: 'permissions',
  itemName: 'description',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedUserPermissions,
};
